import { forwardRef } from 'react';
import { BITTE_BLACK_IMG } from '../../lib/images';
import { ImageWithFallback } from '../ui/ImageWithFallback';

interface AgentPillProps {
  name: string;
  agentImage?: string;
}

export const AgentPill = forwardRef<HTMLDivElement, AgentPillProps>(
  ({ name, agentImage }, ref) => (
    <div
      ref={ref}
      className="bitte-w-fit bitte-flex bitte-items-center bitte-gap-2 bitte-px-2 bitte-py-1 bitte-absolute bitte-left-2 bitte-top-1/2 bitte--translate-y-1/2"
    >
      {agentImage ? (
        <ImageWithFallback
          src={agentImage}
          fallbackSrc={BITTE_BLACK_IMG}
          className="bitte-h-4 bitte-w-4 bitte-rounded-full"
          alt={`${name} icon`}
        />
      ) : (
        <span className="bitte-text-xs bitte-font-semibold bitte-uppercase bitte-text-purple-400">
          {name}
        </span>
      )}
    </div>
  ),
);

AgentPill.displayName = 'AgentPill';
